'use client';

import { c as _c } from "react/compiler-runtime";
import { useAuth, useSdkTurnkey } from '@morfi/backend-sdk-v2/client';
import { useTranslations } from 'next-intl';
import { PendingGiftsBadge } from '@/components/gift/pending-gifts-badge';
import { AnimatedButton } from '@/components/ui/animated-button';
import { Skeleton } from '@/components/ui/app-skeleton';
import { useGiftNotificationsRealtime } from '@/hooks/gifts/use-gift-notifications';
import { captureReturnToAfterAuth } from '@/lib/auth/next-url';
import { WalletDropdown } from './wallet-dropdown';
export function AuthHeaderSection() {
  const $ = _c(19);
  const {
    isAuthenticated,
    isLoading
  } = useAuth();
  const {
    handleLogin
  } = useSdkTurnkey();
  const t = useTranslations("header");
  useGiftNotificationsRealtime();
  if (isLoading) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Skeleton className="h-8 w-24 rounded-full" />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  if (!isAuthenticated) {
    let t0;
    if ($[1] !== handleLogin) {
      t0 = () => {
        captureReturnToAfterAuth();
        handleLogin();
      };
      $[1] = handleLogin;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    let t1;
    if ($[3] !== t) {
      t1 = t("log_in");
      $[3] = t;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    let t2;
    if ($[5] !== t0 || $[6] !== t1) {
      t2 = <AnimatedButton variant="secondary" size="sm" onClick={t0}>{t1}</AnimatedButton>;
      $[5] = t0;
      $[6] = t1;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    let t3;
    if ($[8] !== handleLogin) {
      t3 = () => {
        captureReturnToAfterAuth();
        handleLogin();
      };
      $[8] = handleLogin;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    let t4;
    if ($[10] !== t) {
      t4 = t("sign_up");
      $[10] = t;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    let t5;
    if ($[12] !== t3 || $[13] !== t4) {
      t5 = <AnimatedButton variant="primary" size="sm" onClick={t3}>{t4}</AnimatedButton>;
      $[12] = t3;
      $[13] = t4;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    let t6;
    if ($[15] !== t2 || $[16] !== t5) {
      t6 = <div className="flex shrink-0 items-center gap-2 transition-opacity duration-fast ease-default motion-reduce:transition-none">{t2}{t5}</div>;
      $[15] = t2;
      $[16] = t5;
      $[17] = t6;
    } else {
      t6 = $[17];
    }
    return t6;
  }
  let t0;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><PendingGiftsBadge /><WalletDropdown /></>;
    $[18] = t0;
  } else {
    t0 = $[18];
  }
  return t0;
}